import {ICoordinate} from '../interface';

const libraries = ["drawing", "places", "geometry"];

interface IPosition {
  address: string;
  coordinate: ICoordinate;
}

const MY_POSITION: IPosition = {
  address: 'Berlin, Germany',
  coordinate: {
    lat: 52.540006,
    lng: 13.404954,
  },
};

const ZOOM = 12;

export {MY_POSITION, ZOOM, libraries};
